import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-intl-redux';
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import rootReducer from './store/reducers';
import App from './app';
import apiMiddleware from './store/apiMiddleware';
import et from 'react-intl/locale-data/et';
import { addLocaleData } from 'react-intl';
import JSON5 from 'json5';
import { flattenJson } from './components/utils';
// import german from './translation.json';

const composeEnhancers = composeWithDevTools({
    // Specify name here, actionsBlacklist, actionsCreators and other options if needed
});
const store = createStore(rootReducer, composeEnhancers(applyMiddleware(apiMiddleware)));

render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
);

// locale handling
const { locale } = document.getElementById('root').dataset;
addLocaleData([...et]);
fetch(`./assets/locales/${locale}/translation.json5`)
    .then(response => response.text())
    .then(txt => JSON5.parse(txt))
    .then(json => {
        const messages = flattenJson(json);
        store.dispatch({ type: 'SET__LANGUAGE', locale, messages });
    })
    .catch(err => console.error(err));
